import { render, staticRenderFns } from "./RepairPlanCommentsPage.vue?vue&type=template&id=7788b7d6&"
import script from "./RepairPlanCommentsPage.vue?vue&type=script&lang=ts&"
export * from "./RepairPlanCommentsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports